import React, { useState } from "react";
import { Modal, Stack, Form, Button, Spinner } from "react-bootstrap";
import editarProducto from "../functions/editarProducto";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import firebaseApp from "../firebase/credenciales";
import { logBusinessAction } from "../services/AuditService";

const storage = getStorage(firebaseApp);

function ModalEditarReglamentos({
  isModalEditar,
  setIsModalEditar,
  actualizarEstadoProductos,
  productoEditar,
  setProductoEditar,
  usuario,
}) {
  const [productoEstado, setProductoEstado] = useState({ ...productoEditar });
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  // Actualiza el estado local si cambia el producto a editar
  React.useEffect(() => {
    setProductoEstado({ ...productoEditar });
    setFile(null);
  }, [productoEditar]);

  // Solo permite PDF y máximo 10MB
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) {
      setFile(null);
      return;
    }
    if (selectedFile.type !== "application/pdf") {
      alert("Solo se permiten archivos PDF.");
      setFile(null);
      e.target.value = "";
      return;
    }
    if (selectedFile.size > 10 * 1024 * 1024) {
      alert("El archivo no debe superar los 10MB.");
      setFile(null);
      e.target.value = "";
      return;
    }
    setFile(selectedFile);
  };

  async function editarProductoModal() {
    const ruc = usuario.ruc;
    const activo = true;
    const codigo = productoEstado.codigo?.trim();
    const nombre = productoEstado.nombre?.trim().toUpperCase();
    const descripcion = productoEstado.descripcion?.trim().toUpperCase();
    const rev = productoEstado.rev?.trim().toUpperCase();
    const orden = productoEstado.orden;
    let url = productoEstado.url?.trim();
    const baseDatos = `reglamentos`;

    setLoading(true);

    try {
      // Si el usuario seleccionó un nuevo archivo, súbelo y actualiza el link
      if (file) {
        const storageRef = ref(storage, `reglamentos/${ruc}/${file.name}`);
        await uploadBytes(storageRef, file);
        url = await getDownloadURL(storageRef);
      }

      // No modificar el link, respeta mayúsculas/minúsculas
      const infoProducto = { activo, codigo, nombre, descripcion, rev, orden, url, ruc };
      await editarProducto(infoProducto, usuario.email, baseDatos, productoEditar.id);

      // AUDITORÍA
      try {
        const cambios = {};
        if (productoEditar.nombre !== nombre) cambios.nombre = { anterior: productoEditar.nombre, nuevo: nombre };
        if (productoEditar.codigo !== codigo) cambios.codigo = { anterior: productoEditar.codigo, nuevo: codigo };
        if (productoEditar.rev !== rev) cambios.revision = { anterior: productoEditar.rev, nuevo: rev };
        if (productoEditar.url !== url) cambios.archivo = { anterior: productoEditar.url, nuevo: url };

        if (Object.keys(cambios).length > 0) {
          await logBusinessAction("EDICION_REGLAMENTO_POLITICA", "GestionDocumentos", {
            documentoId: productoEditar.id,
            cambiosRealizados: cambios
          }, usuario);
        }
      } catch (e) {
        console.warn("No se pudo registrar la auditoría de edición", e);
      }

      setProductoEditar(null);
      actualizarEstadoProductos(baseDatos);
      setIsModalEditar(false);
    } catch (err) {
      alert("Error al editar el documento");
      console.error(err);
    }
    setLoading(false);
  }

  return (
    <Modal
      show={isModalEditar}
      onHide={() => {
        setIsModalEditar(false);
        setProductoEditar(null);
      }}
    >
      <Modal.Header>
        <Modal.Title>Editar Reglamento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Stack>
            <Form.Control
              id="codigo"
              placeholder="Código"
              type="text"
              className="mb-1"
              value={productoEstado?.codigo || ""}
              onChange={(e) =>
                setProductoEstado({
                  ...productoEstado,
                  codigo: e.target.value,
                })
              }
            />
            <Form.Control
              id="nombre"
              placeholder="Nombre"
              type="text"
              className="mb-1"
              value={productoEstado?.nombre || ""}
              onChange={(e) =>
                setProductoEstado({
                  ...productoEstado,
                  nombre: e.target.value,
                })
              }
            />
            <Form.Control
              id="descripcion"
              placeholder="Descripción"
              type="text"
              className="mb-1"
              value={productoEstado?.descripcion || ""}
              onChange={(e) =>
                setProductoEstado({
                  ...productoEstado,
                  descripcion: e.target.value,
                })
              }
            />
            <Form.Control
              id="rev"
              placeholder="Revisión"
              type="text"
              className="mb-1"
              value={productoEstado?.rev || ""}
              onChange={(e) =>
                setProductoEstado({
                  ...productoEstado,
                  rev: e.target.value,
                })
              }
            />
            <Form.Control
              id="orden"
              placeholder="Orden"
              type="number"
              className="mb-1"
              value={productoEstado?.orden || ""}
              onChange={(e) =>
                setProductoEstado({
                  ...productoEstado,
                  orden: e.target.value,
                })
              }
            />
            <Form.Control
              id="url"
              placeholder="Url"
              type="text"
              className="mb-1"
              value={productoEstado?.url || ""}
              onChange={(e) =>
                setProductoEstado({
                  ...productoEstado,
                  url: e.target.value,
                })
              }
            />
            <Form.Label className="mt-2">Actualizar PDF (opcional, máx. 10MB)</Form.Label>
            <Form.Control
              type="file"
              accept="application/pdf"
              onChange={handleFileChange}
              className="mb-2"
            />
          </Stack>
        </Form>
        {loading && (
          <div className="text-center mt-2">
            <Spinner animation="border" size="sm" /> Guardando...
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            setIsModalEditar(false);
            setProductoEditar(null);
          }}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button variant="primary" onClick={editarProductoModal} disabled={loading}>
          Editar
        </Button>
      </Modal.Footer>
      </Modal>
  );
}

export default ModalEditarReglamentos;